import DictionaryComponent from './DictionaryComponent';
export default DictionaryComponent;
